import { Sale as S } from "./Listing";
export default function Sale() { return <S />; }
